// src/models/portfolioData.js
// MODEL LAYER — pure data, no logic

import telzenHome from '../assets/telzen-home.jpg';
import telzenPackages from '../assets/telzen-packages.jpg';
import telzenCheckout from '../assets/telzen-checkout.jpg';
import telzenCompatibility from '../assets/telzen-compatibility.jpg';
import kangaHome from '../assets/kanga-home.jpg';
import kangaStore from '../assets/kanga-store.jpg';
import kangaDetails from '../assets/kanga-details.jpg';
import kangaLifestyle from '../assets/kanga-lifestyle.jpg';
import kidsImage01 from '../assets/kids-ai.png';
import quickDrawBanner from '../assets/quickdraw-banner.png';
import quickDrawWorkstation from '../assets/quickdraw-workstation.jpg';
import quickDrawPayment from '../assets/quickdraw-payment.jpg';
import easyTruckImage from '../assets/easy-truck.png';
import freqonBrand from '../assets/freqon-brand.png';
import freqonPlayer from '../assets/freqon-player.png';
import unisaviScreens from '../assets/unisavi-screens.jpg';
import unisaviSplash from '../assets/unisavi-splash.jpg';
import unisaviBrand from '../assets/unisavi-brand.jpg';
import blogCleanArchitecture from '../assets/blog-clean-architecture.png';
import blogStateManagement from '../assets/blog-state-management.png';

import wisperbotCustomerSdkChat from '../assets/case-studies/wisperbot-customer-sdk-chat.png';
import wisperbotAgentPostScheduling from '../assets/case-studies/wisperbot-agent-post-scheduling.png';
import wisperbotAgentSettings from '../assets/case-studies/wisperbot-agent-settings.png';
import wisperbotArchitecture from '../assets/case-studies/wisperbot-architecture.png';

import gellaryTelzenMilestone from '../assets/gellary/telzen-celebration.jpg';
import gellaryNetro01 from '../assets/gellary/netro-celebration.jpg';
import gellaryNetro02 from '../assets/gellary/netro-cultural.jpg';
import gellaryNetro03 from '../assets/gellary/netro-workstation.jpg';
import gellaryNetro04 from '../assets/gellary/netro-hangout.jpg';

import gellaryCovid01 from '../assets/gellary/covid01.jpeg';
import gellaryCovid02 from '../assets/gellary/covid02.jpeg';
import gellaryCovid03 from '../assets/gellary/covid03.jpeg';
import gellaryCovid04 from '../assets/gellary/covid04.jpeg';
import gellaryIct05 from '../assets/gellary/ict.jpeg';
import gellaryCivil06 from '../assets/gellary/civil-sergion.jpeg';

export const developer = {
  name: 'ISMAIL JABIULLA',
  role: 'Software Engineer',
  tagline: 'Building beautiful cross-platform mobile apps',
  intro:
    "I’m a Software Engineer who enjoys turning ideas into practical, reliable, and scalable software solutions. I take ownership of projects from development to deployment, collaborate with teams to solve challenges, and continuously explore new technologies. I use AI and modern engineering practices to work smarter, improve software quality, and build products that create real value for people.",
  email: 'ismailjabiulla06@gmail.com',
  github: 'https://www.github.com/MrJabiulla',
  linkedin: 'https://www.linkedin.com/in/mr-jabiulla',
  fiverr: 'https://www.fiverr.com/ismail_jabiulla',
  stats: [
    { num: '3+', label: 'Years Experience' },
    { num: '10+', label: 'Apps Delivered' },
    { num: '3', label: 'Payment Gateways' },
    { num: '11+', label: 'Tech Stack' },
  ],
};

export const skills = [
  {
    category: 'Mobile Engineering',
    items: [
      { name: 'Dart' },
      { name: 'Flutter' },
      { name: 'Responsive UI' },
      { name: 'Animations' },
      { name: 'App Publishing' },
    ],
  },
  {
    category: 'Native iOS',
    items: [
      { name: 'Swift' },
      { name: 'SwiftUI' },
      { name: 'Xcode' },
      { name: 'iOS Integrations' },
    ],
  },
  {
    category: 'Backend & Cloud',
    items: [
      { name: 'Firebase' },
      { name: 'Supabase' },
      { name: 'REST APIs' },
      { name: 'Authentication' },
      { name: 'Push Notifications' },
      { name: 'Real-time Communication' },
    ],
  },
  {
    category: 'Architecture & Design Patterns',
    items: [
      { name: 'Clean Architecture' },
      { name: 'MVVM' },
      { name: 'BLoC' },
      { name: 'Provider' },
      { name: 'GetX' },
      { name: 'SOLID Principles' },
    ],
  },
  {
    category: 'DevOps & App Delivery',
    items: [
      { name: 'Git & GitHub' },
      { name: 'GitHub Actions' },
      { name: 'CI/CD' },
      { name: 'App Store Connect' },
      { name: 'Google Play Console' },
    ],
  },
  {
    category: 'AI & Engineering Productivity',
    items: [
      { name: 'AI-Assisted Development' },
      { name: 'Workflow Automation' },
      { name: 'Intelligent Code Reviews' },
      { name: 'AI Problem Solving' },
      { name: 'Agentic AI' },
      { name: 'Developer Productivity' },
    ],
  },
];

// Each project has media: array of { type: 'image'|'video', url, thumb, alt }
export const projects = [
{
  id: 1,
  title: 'Telzen - eSIM for Travelers',
  description: 'Global eSIM platform for purchasing, activating, and managing data plans worldwide.',
  category: 'Travel',
  longDesc:
    'Telzen is a global eSIM platform designed for modern travelers, enabling users to purchase and activate country-based and region-based data plans directly from the app. It supports seamless installation on both Android and iOS with instant activation and region-wide usability. The app includes live data usage tracking, secure payment processing, multiple authentication options, and built-in fraud protection. A coupon-based gifting system enhances user engagement, while its clean architecture and optimized performance ensure a reliable experience even in low-connectivity environments.',
  tags: ['flutter', 'esim', 'telecom', 'payment'],
  tech: [
    'Flutter',
    'GetX',
    'bKash / Nagad',
    'Stripe',
    'SurjoPay',
    'PayPal',
    'REST API',
    'Push Notification',
    'Google Auth',
    'Apple Auth',
    'Clean Architecture',
    'SOLID Principles'
  ],
  gradient: 'from-indigo-900 to-purple-950',
  emoji: '📱',
  accentColor: '#6366f1',
  media: [
    {
      type: 'image',
      url: telzenHome,
      thumb: telzenHome,
      alt: 'Telzen - Home Dashboard & Live eSIM Usage Tracking'
    },
    {
      type: 'image',
      url: telzenPackages,
      thumb: telzenPackages,
      alt: 'Telzen - Country & Regional Data Plans'
    },
    {
      type: 'image',
      url: telzenCheckout,
      thumb: telzenCheckout,
      alt: 'Telzen - Order Summary & Multi-Payment Checkout'
    },
    {
      type: 'image',
      url: telzenCompatibility,
      thumb: telzenCompatibility,
      alt: 'Telzen - Automated Device eSIM Compatibility Checker'
    }
  ],
  features: [
    'Real-time eSIM usage tracking & quick balance refill',
    'Country and regional data plans with flexible validity options (7, 15, 30 days)',
    'Transparent order summary & localized checkout (bKash, Nagad, Stripe, Cards)',
    'Automated device eSIM hardware and OS compatibility verification',
    'Instant global eSIM purchase and one-tap activation',
    'Coupon discount redemption and gifting system',
    'Social authentication (Google & Apple) with secure token handling',
    'Push notifications for usage threshold alerts and offers'
  ],
  challenges:
    'Integrating multiple global and localized payment gateways (bKash, Nagad, Stripe, PayPal) and ensuring reliable eSIM activation flows across different regions, while maintaining secure transactions, fraud prevention, and seamless user experience under varying network conditions.',
  caseStudySlug: 'telzen',
  github: null,
  appstore: 'https://tinyurl.com/bdsrazpn',
  playstore: 'https://tinyurl.com/79vr996b',
},

{
  id: 2,
  title: 'Kanga',
  description: 'Location-based service booking and business discovery platform.',
  category: 'Business',
  longDesc:
    'Kanga is a service booking application that enables users to discover nearby businesses and make reservations seamlessly. The platform supports location-based service discovery, restaurant bookings, and real-time interaction between users and service providers using socket-based communication. It includes advanced features like recurring and rescheduling bookings, secure payment integration with Stripe, and real-time chat functionality. Built with a scalable architecture, the app ensures smooth billing, reliable notifications, and secure authentication for an optimized user experience.',
  tags: ['flutter', 'booking', 'socket', 'payment'],
  tech: [
    'Flutter',
    'Dart',
    'Firebase',
    'Stripe',
    'Socket.io',
    'GetX',
    'REST API',
    'Push Notification',
    'Real-time Communication'
  ],
  emoji: '🌾',
  gradient: 'from-emerald-950 to-teal-900',
  accentColor: '#10b981',
  media: [
    {
      type: 'image',
      url: kangaHome,
      thumb: kangaHome,
      alt: 'Kanga - Nearby Service Discovery & Categories'
    },
    {
      type: 'image',
      url: kangaStore,
      thumb: kangaStore,
      alt: 'Kanga - Business Storefront, Gallery & Reviews'
    },
    {
      type: 'image',
      url: kangaDetails,
      thumb: kangaDetails,
      alt: 'Kanga - Operating Schedule, Amenities & Owner Info'
    },
    {
      type: 'image',
      url: kangaLifestyle,
      thumb: kangaLifestyle,
      alt: 'Kanga - Lifestyle Mobile Experience'
    }
  ],
  features: [
    'Location-based service and multi-category business discovery',
    'Interactive business storefront with image galleries and verified reviews',
    'Detailed business hours, amenities list, and owner profiles',
    'Real-time chat with service providers using Socket.io',
    'Online appointment booking and rescheduling system',
    'Secure payment processing with Stripe integration',
    'Push notifications for appointment reminders and updates',
    'User authentication and personalized recommendations'
  ],
  challenges:
    'Implementing real-time booking updates and chat using socket communication while ensuring data consistency, handling connection drops, and maintaining accurate billing with Stripe integration.',
  github: null,
  appstore: 'https://tinyurl.com/57m23hdp',
  playstore: 'https://tinyurl.com/yat8523s'
},
{
  id: 3,
  title: 'Kids AI',
  description: 'Parenting support app with AI-driven insights, activities, and child care services.',
  category: 'Kids & Parenting',
  longDesc:
    'Kids AI is a parenting support application designed to assist parents in managing their child’s growth and well-being. The app includes mood tracking, AI-based parenting advice, doctor booking, and curated activities and videos for children. It supports multi-language usage, guest login, and in-app purchases for premium features. As an early-stage project, it helped establish strong fundamentals in mobile development, focusing on performance optimization, clean UI design, and real-world problem solving to deliver a smooth and engaging user experience.',
  tags: ['flutter', 'ai', 'parenting', 'mobile app'],
  tech: [
    'Flutter',
    'Dart',
    'GetX',
    'REST API',
    'In-App Purchase',
    'Multi-language Support'
  ],
  emoji: '🧒',
  gradient: 'from-pink-900 to-purple-900',
  accentColor: '#ec4899',
  media: [ 
    { type: 'image', url: kidsImage01, thumb: kidsImage01, alt: 'Kids AI' }, 
],
  features: [
    'Mood tracking for children',
    'AI-based parenting advice',
    'Doctor booking system',
    'Educational activities and videos',
    'Multi-language support',
    'Guest login and user authentication',
    'In-app purchases for premium features'
  ],
  challenges:
    'Designing an intuitive user experience for parents while integrating AI-based suggestions and maintaining smooth performance across different devices.',
  github: null,
  appstore: 'https://apps.apple.com',
  playstore: 'https://play.google.com'
},
{
  "id": 4,
  "title": "Quick Draw (POS)",
  "description": "Flutter-based POS app for lottery system with ticket purchase, payment processing, and device integration.",
  "category": "Fintech / POS",
  "longDesc": "Quick Draw is a Flutter-based Point of Sale (POS) application built for lottery and quick draw game systems. It enables users to purchase tickets, manage transactions, process payments via QR and direct methods, and print receipts using Sunmi and Telpo POS devices. The app includes secure OTP-based authentication, real-time ticket handling, and a dashboard for tracking sales, due payments, and prize distribution.",
  "tags": ["flutter", "pos", "lottery", "payment", "printing"],
  "tech": ["Flutter", "Dart", "GetX", "REST API", "Sunmi Device", "Telpo Device", "QR Code"],
  "emoji": "🎟️",
  "gradient": "from-emerald-950 to-teal-900",
  "accentColor": "#10b981",
  media: [
    {
      type: 'image',
      url: quickDrawBanner,
      thumb: quickDrawBanner,
      alt: 'Quick Draw - POS Lottery Brand'
    },
    {
      type: 'image',
      url: quickDrawWorkstation,
      thumb: quickDrawWorkstation,
      alt: 'Quick Draw - Hardware Integration & Development (Sunmi & Telpo POS)'
    },
    {
      type: 'image',
      url: quickDrawPayment,
      thumb: quickDrawPayment,
      alt: 'Quick Draw - Payment Success & Thermal Invoice Printing'
    }
  ],
  features: [
    'Secure authentication with email OTP verification',
    'Lottery ticket purchase with multiple game types (Straight, Chance, Random)',
    'Real-time ticket management and automatic order verification',
    'Integrated payment system with QR code and card support',
    'Sunmi and Telpo POS device integration with instant thermal invoice printing',
    'Sales dashboard with real-time analytics (sales, due payments, prizes)',
    'Responsive UI optimized for POS hardware and mobile devices'
  ],
  "challenges": "Handling real-time ticket generation and ensuring accurate transaction processing with seamless integration of POS devices (Sunmi, Telpo) while maintaining performance and reliability.",
  "github": null,
  "appstore": null,
  "playstore": null
},
 {
  id: 5,
  title: 'Unisavi',
  description: 'Global education platform connecting students with universities worldwide.',
  category: 'Education',
  longDesc:
    'Unisavi is a global education platform designed to help students explore universities and pursue international studies with ease. The app allows users to discover institutions across different countries, explore detailed course offerings, and apply directly through the platform. It also includes funding and loan management features to track financial support requests, approval status, and repayment details. Built with a clean architecture approach, the app focuses on simplicity, transparency, and a user-friendly experience for students planning their academic journey abroad.',
  tags: ['flutter', 'education', 'rest api', 'ai'],
  tech: [
    'Flutter',
    'Dart',
    'GetX',
    'Flutterwave',
    'Freshdesk',
    'REST API',
    'Clean Architecture',
    'SOLID Principles'
  ],
  emoji: '🎓',
  gradient: 'from-violet-950 to-indigo-900',
  accentColor: '#8b5cf6',
  media: [
    {
      type: 'image',
      url: unisaviSplash,
      thumb: unisaviSplash,
      alt: 'Unisavi - Brand & Mobile Experience'
    },
    {
      type: 'image',
      url: unisaviBrand,
      thumb: unisaviBrand,
      alt: 'Unisavi - Official Platform Mockup'
    },
    {
      type: 'image',
      url: unisaviScreens,
      thumb: unisaviScreens,
      alt: 'Unisavi - AI Course Matches & Institution Details'
    }
  ],
  features: [
    'AI-powered course matching with compatibility scoring',
    'Global institution and course discovery across countries',
    'Detailed university profiles with intake cycles and study levels',
    'Direct application system with profile readiness tracking',
    'PayTrack: Tuition funding, loan management, and fee tracking',
    'Smart search filters (Affordable, HND Friendly, Fee Waivers)',
    'In-app student support powered by Freshdesk'
  ],
  challenges:
    'Designing a scalable system to handle diverse university data, application workflows, and financial tracking while maintaining a simple and intuitive user experience.',
  github: null,
  appstore: 'https://apps.apple.com/ng/app/unisavi/id6752886962',
  playstore: 'https://play.google.com/store/apps/details?id=com.unisavi.app.unisavi&hl=en'
},
{
  id: 6,
  title: 'Easy Truck',
  description: 'Logistics and truck booking platform with real-time tracking and digital payments.',
  category: 'Business',
  longDesc:
    'Easy Truck is part of the Easy Venture ecosystem, a logistics and supply chain platform that includes modules for truck owners, drivers, retail, and office management. The app enables efficient truck booking, real-time vehicle tracking using Google Maps, and seamless coordination between stakeholders. It also supports digital payments through bKash, making transactions সহজ and accessible. Integrated with Easy Brick for brick sales and staff operations, the platform is built with clean architecture and optimized workflows to ensure scalability and reliability in real-world logistics operations.',
  tags: ['flutter', 'logistics', 'map', 'payment'],
  tech: [
    'Flutter',
    'Dart',
    'BLoC',
    'REST API',
    'Google Maps API',
    'bKash Payment Gateway',
    'Clean Architecture',
    'SOLID Principles'
  ],
  emoji: '🚚',
  gradient: 'from-cyan-950 to-blue-900',
  accentColor: '#06b6d4',
  media: [
    {
      type: 'image',
      url: easyTruckImage,
      thumb: easyTruckImage,
      alt: 'Easy Truck - Logistics & Trip Management Platform'
    }
  ],
  features: [
    'Truck booking and logistics management',
    'Real-time truck tracking with Google Maps',
    'Role-based modules (Owner, Driver, Retail, Office)',
    'Order and delivery tracking system',
    'bKash digital payment integration',
    'Integration with Easy Brick (sales & staff management)',
    'Real-time status updates and coordination',
    'Optimized workflows for logistics operations'
  ],
  challenges:
    'Implementing real-time location tracking with Google Maps while ensuring accurate updates, low latency, and handling network fluctuations, alongside secure and reliable bKash payment processing within a multi-role logistics system.',
  github: 'https://github.com/ismailjabiulla/chatnow',
  appstore: null,
  playstore: 'https://play.google.com'
},
{
  id: 7,
  title: 'FreqOn Radio',
  description: 'Global live radio streaming platform with background audio playback, categorized stations, and favorites.',
  category: 'Entertainment',
  longDesc:
    'FreqOn Radio is a global radio streaming application built with Flutter that connects users to live radio broadcasts from countries around the world. The app offers crystal-clear audio playback across multiple genres including Music, News, and Sports. Key technical highlights include seamless background audio streaming with native lock screen and notification shade controls, efficient audio caching, station categorization, and an intuitive favorites system. Built with clean architecture, FreqOn Radio is engineered for smooth, battery-efficient, and buffer-free audio delivery.',
  tags: ['flutter', 'audio', 'streaming', 'background-tasks'],
  tech: [
    'Flutter',
    'Dart',
    'Audio Service',
    'Just Audio',
    'Background Processing',
    'REST API',
    'Clean Architecture',
    'GetX'
  ],
  emoji: '📻',
  gradient: 'from-amber-950 to-orange-900',
  accentColor: '#f97316',
  media: [
    {
      type: 'image',
      url: freqonBrand,
      thumb: freqonBrand,
      alt: 'FreqOn Radio - Onboarding, Categories & Favourites'
    },
    {
      type: 'image',
      url: freqonPlayer,
      thumb: freqonPlayer,
      alt: 'FreqOn Radio - Home Feed, Live Audio Player & Background Notification'
    }
  ],
  features: [
    'Live international radio streaming across multiple countries and genres',
    'Background audio playback with native media notification and lock screen controls',
    'Categorized station discovery (Country-wise, Sports, News, Music)',
    'Live streaming audio player with real-time waveform visualization',
    'Personalized favorites and station bookmarking',
    'Low-latency audio streaming with intelligent buffering',
    'Modern, vibrant UI with responsive cross-platform support'
  ],
  challenges:
    'Ensuring smooth, continuous audio streaming in the background across various OS battery optimization rules while synchronizing lock screen media controls and handling network drops seamlessly.',
  github: null,
  appstore: null,
  playstore: 'https://play.google.com'
},
{
  id: 8,
  title: 'WisperBot - SDK & Agent Workspace',
  description: 'Open source Flutter chat SDK on pub.dev and cross-platform agent mobile workspace application.',
  category: 'Communication / SDK',
  longDesc:
    'WisperBot connects the customer chat experience with the mobile workspace agents use to manage support. Developed and published as an open-source Flutter SDK (wisperbot_chat on pub.dev) and a production mobile workspace for support agents across Android and iOS. The SDK features identity-scoped sessions, interactive suggested questions, real-time message delivery receipts, and media attachments. The agent mobile app provides multi-workspace inboxes, social post scheduling with calendar views, live visitor maps, and fine-grained notifications.',
  tags: ['flutter', 'sdk', 'chat', 'socket', 'open-source'],
  tech: [
    'Flutter',
    'Dart',
    'pub.dev Publishing',
    'WebSockets',
    'Socket.io',
    'REST API',
    'Push Notification',
    'Clean Architecture',
    'SOLID Principles',
    'Offline Persistence'
  ],
  emoji: '💬',
  gradient: 'from-orange-950 via-amber-900 to-rose-950',
  accentColor: '#f97316',
  media: [
    {
      type: 'image',
      url: wisperbotCustomerSdkChat,
      thumb: wisperbotCustomerSdkChat,
      alt: 'WisperBot - Flutter Customer Support SDK Embedded in Host App'
    },
    {
      type: 'image',
      url: wisperbotAgentPostScheduling,
      thumb: wisperbotAgentPostScheduling,
      alt: 'WisperBot - Agent Mobile Workspace Post Scheduling & Calendar'
    },
    {
      type: 'image',
      url: wisperbotAgentSettings,
      thumb: wisperbotAgentSettings,
      alt: 'WisperBot - Mobile Settings, Multi-theme & Push Notifications'
    },
    {
      type: 'image',
      url: wisperbotArchitecture,
      thumb: wisperbotArchitecture,
      alt: 'WisperBot - Architecture & Boundary Relationship'
    }
  ],
  features: [
    'Open source Flutter SDK published on pub.dev (wisperbot_chat)',
    'Full-featured mobile workspace for support agents (Android & iOS)',
    'Real-time WebSocket chat with delivery receipts and typing indicators',
    'Interactive suggested prompts and multi-option attachment picker',
    'Multi-workspace context switching with state isolation',
    'Social post scheduling with list and monthly calendar views',
    'Offline draft persistence and automatic socket reconnection with queue replay',
    'Granular push notification routing and deep linking into conversations'
  ],
  challenges:
    'Coordinating rapid workspace switches, notification navigation, API responses, and live socket streams without state collisions or memory leaks, while ensuring the SDK cleanly embeds inside third-party apps without polluting host lifecycle.',
  caseStudySlug: 'wisperbot',
  pubdev: 'https://pub.dev/packages/wisperbot_chat',
  github: null,
  appstore: 'https://apps.apple.com',
  playstore: 'https://play.google.com'
}
];

export const experience = [
  {
  "id": 1,
  "company": "Netro Systems Ltd.",
  "role": "Software Engineer L-II",
  "period": "Jan 2024 – Present",
  "location": "Hi-tech Park, Rajshahi, Bangladesh",
  "type": "Full-time",
  "color": "#f97316",
  "careerProgression": [
    {
      "role": "Software Engineer L-II",
      "period": "Jul 2025 – Present"
    },
    {
      "role": "Software Engineer L-I",
      "period": "Jan 2025 – Jun 2025"
    },
    {
      "role": "Jr. Software Engineer L-II",
      "period": "Aug 2024 – Jan 2025"
    },
    {
      "role": "Jr. Software Engineer L-I / Intern",
      "period": "Jan 2024 – Aug 2024"
    }
  ],
  "points": [
    "Building scalable applications, leading development teams, and taking end-to-end ownership of projects from planning to deployment.",
    "Experienced in Flutter, backend integrations, cloud services, and CI/CD, with published applications serving 20K+ users.",
    "Leveraging AI-driven workflows to improve development efficiency, code quality, and application performance."
  ],
  "stack": [
    "Flutter",
    "Dart",
    "Firebase",
    "Stripe",
    "SurjoPay",
    "BLoC",
    "GetX",
    "REST API",
    "CI/CD"
  ]
},
  {
  "id": 2,
  "company": "ICT Division",
  "role": "Trainer (Contractual)",
  "period": "Jul 2023 – Nov 2023",
  "location": "Naogoan, Bangladesh",
  "type": "Full-time",
  "color": "#06b6d4",
  "points": [
    "I worked as an ICT Trainer in a project under the ICT Division, through which teachers were provided ICT training to enhance their digital competencies. I conducted training sessions and contributed to promoting effective use of technology in the education sector."
  ],
  "stack": []
},
{
  "id": 3,
  "company": "Civil Surgeon Office, Rajshahi",
  "role": "Data Entry Operator (Contractual)",
  "period": "Feb 2022 – Apr 2023",
  "location": "Rajshahi, Bangladesh",
  "type": "Full-time",
  "color": "#10b981",
  "points": [
    "During the COVID-19 pandemic, I worked at the Rajshahi Civil Surgeon Office, where I managed vaccine data, reported to DGHS, supported vaccination campaigns, and handled stock management.",
    "Served as an active member of the Rajshahi district unit under BDRC and IFRC deployment."
  ],
  "stack": []
}
];

export const contactInfo = [
  { label: 'Email', value: 'ismail.jabiulla@gmail.com', href: 'mailto:ismail.jabiulla@gmail.com', icon: 'mail' },
  { label: 'GitHub', value: 'github.com/ismailjabiulla', href: 'https://github.com/ismailjabiulla', icon: 'github' },
  { label: 'LinkedIn', value: 'linkedin.com/in/ismailjabiulla', href: 'https://linkedin.com/in/ismailjabiulla', icon: 'linkedin' },
];

export const filterTabs = ['all', 'flutter', 'sdk', 'payment', 'pos', 'rest api', 'swift'];

export const publications = [
  {
    id: 1,
    title: 'Wisperbot Chat',
    description: 'A customizable, battery-efficient Flutter SDK for embedding WisperBot customer support chat into mobile, web, and desktop apps. Features identity-scoped visitor sessions, real-time messaging, customizable UI, and push notifications.',
    publication: 'pub.dev',
    date: 'Oct 2026',
    tags: ['flutter', 'chat', 'sdk', 'real-time', 'package'],
    link: 'https://pub.dev/packages/wisperbot_chat',
    caseStudySlug: 'wisperbot',
  },
  {
    id: 2,
    title: 'Flutter Background Wraper',
    description: 'A lightweight Flutter package for managing background tasks and keeping your app active in the background with minimal battery consumption. Provides easy-to-use APIs for background processing, foreground services, and task scheduling.',
    publication: 'pub.dev',
    date: 'Nov 2024',
    tags: ['flutter', 'background-tasks', 'package', 'performance'],
    link: 'https://pub.dev/packages/flutter_background_wraper/install',
  },
];

export const blogs = [
  {
    id: 1,
    title: 'Building Scalable Flutter Apps with Clean Architecture',
    image: blogCleanArchitecture,
    description: 'A comprehensive guide to implementing clean architecture principles in Flutter applications, covering layers, dependency injection, and best practices for maintainable and testable code.',
    publication: 'Dev.to',
    date: 'Mar 2024',
    tags: ['flutter', 'architecture', 'clean-code'],
    link: 'https://github.com/MrJabiulla',
  },
  {
    id: 2,
    title: 'State Management in Flutter: BLoC vs GetX vs Provider',
    image: blogStateManagement,
    description: 'Comparative analysis of popular state management solutions in Flutter, evaluating performance, complexity, testability, and real-world production use cases.',
    publication: 'Medium',
    date: 'Feb 2024',
    tags: ['flutter', 'state-management', 'performance'],
    link: 'https://github.com/MrJabiulla',
  },
];


export const galleryItems = [
  {
    id: 1,
    image: gellaryTelzenMilestone,
    category: 'Netro Systems',
    title: 'Telzen Milestone - 15K+ Active Users & 1M BDT Revenue Celebration',
    summary: 'Celebrating Telzen reaching massive milestones — surpassing 15,000+ active users and crossing 1M+ BDT in revenue with the engineering and product team at Netro Systems Ltd.',
  },
  {
    id: 2,
    image: gellaryNetro01,
    category: 'Netro Systems',
    title: 'Netro Systems - Birthday Celebration',
    summary: 'Celebrating my birthday with wonderful colleagues and teammates at Netro Systems Ltd.',
  },
  {
    id: 3,
    image: gellaryNetro03,
    category: 'Netro Systems',
    title: 'Netro Systems - Tech Sprint & Engineering Discussion',
    summary: 'Architecture planning, mobile app UI/UX reviews, and engineering sprint discussions at the Netro Systems workstation.',
  },
  {
    id: 4,
    image: gellaryNetro02,
    category: 'Netro Systems',
    title: 'Netro Systems - Cultural Festivities (Pohela Boishakh)',
    summary: 'Embracing Bengali cultural heritage, traditions, and festive moments with the Netro Systems family.',
  },
  {
    id: 5,
    image: gellaryNetro04,
    category: 'Netro Systems',
    title: 'Netro Systems - Team Bonding & Lounge Hangout',
    summary: 'Candid moments and team camaraderie at the Netro Systems office lounge, fostering close collaboration and positive culture.',
  },
  {
    id: 6,
    image: gellaryCovid01,
    category: 'Community & Volunteer',
    title: 'Covid-19 Response - Rajshahi District Unit',
    summary: 'Emergency gate RMCH during the COVID-19 pandemic, providing critical support for patient care and resource management. Rajshahi district unit under BDRCS and IFRC deployment.',
  },
  {
    id: 7,
    image: gellaryCovid02,
    category: 'Community & Volunteer',
    title: 'BDRCS Rajshahi District Unit - COVID-19 Response',
    summary: 'Paba upazilla supported emergency medical services during the pandemic with efficient coordination and resource management. Rajshahi district unit under BDRCS and IFRC deployment.',
  },
  {
    id: 8,
    image: gellaryCovid03,
    category: 'Community & Volunteer',
    title: 'BDRCS Rajshahi District Unit - COVID-19 Response',
    summary: 'Supported emergency medical services during the pandemic with efficient coordination and resource management. Rajshahi district unit under BDRCS and IFRC deployment.',
  },
  {
    id: 9,
    image: gellaryCovid04,
    category: 'Community & Volunteer',
    title: 'Ambulance Service - COVID-19 Response',
    summary: 'Supported emergency medical services during the pandemic with efficient coordination and resource management. Rajshahi district unit under BDRCS and IFRC deployment.',
  },
  {
    id: 10,
    image: gellaryIct05,
    category: 'Trainer & Lead',
    title: 'ICT Division - ICT Trainer & Session Lead',
    summary: 'Served as an ICT Trainer and session lead under the ICT Division, conducting specialized training for teachers to enhance digital competencies and technology adoption in education.',
  },
  {
    id: 11,
    image: gellaryCivil06,
    category: 'Community & Volunteer',
    title: 'Civil Surgeon Office, Rajshahi - IFRC Deployment',
    summary: 'Managed vaccine data, supported vaccination campaigns, and contributed to pandemic response efforts.',
  },
];
